import React, { Component } from 'react'
import Color from 'color'
import Radium from 'radium'
import MobileDetect from 'mobile-detect'
import debounce from 'lodash.debounce'
import throttle from 'lodash.throttle'
import { Helmet } from 'react-helmet'
import scrollToComponent from 'react-scroll-to-component';

import Palette from '../components/assets/palette'
import Navbar from '../components/navbar'
import MobileContent from '../components/mobile-content'
import Hero from '../components/hero'
import { BTN_STYLES } from '../components/assets/btns-shared'
import vid0 from '../components/assets/carousel/01.mp4'
import vid1 from '../components/assets/carousel/02.mp4'
import vid2 from '../components/assets/carousel/03.mp4'
import soon01 from '../components/assets/soon/01.svg'
import soon02 from '../components/assets/soon/02.svg'
import soon03 from '../components/assets/soon/03.svg'
import soon04 from '../components/assets/soon/04.svg'
import soon05 from '../components/assets/soon/05.svg'
import Beholder from '@haiku/taylor-beholder2/react';
import Workflowstate from '@haiku/taylor-workflowstate/react'

import { ComponentSVG, MotionSVG, CodeSVG } from '../components/assets/icons'

const windowPresent = (typeof window !== 'undefined')

const md = windowPresent
  ? new MobileDetect(window.navigator.userAgent)
  : { mobile: () => { return false } }
const isMobile = md.mobile()

const isFirefox = typeof InstallTrigger !== 'undefined';
const isSafari = windowPresent
  ? /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification))
  : false

const STYLES = {
  hero: {
    position: 'relative',
    height: 670,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 44,
    '@media screen and (max-width: 1007px)': {
      height: '100%',
    }
  },
  section: {
    position: 'relative',
    fontSize: 20,
    lineHeight: '1.8em',
    width: '100%',
    maxWidth: 1440,
    margin: '0 auto',
    minHeight: 400,
    color: Palette.SUNSTONE,
  },
  overviewContainer: {
    minHeight: 620,
    '@media screen and (max-width: 700px)': {
      minHeight: 300,
    }
  },
  h2: {
    color: Palette.LIGHT_BLUE,
    fontSize: '2.7em',
    textAlign: 'center',
    marginBottom: 30,
    marginTop: 180,
    lineHeight: 1.2,
    '@media screen and (max-width: 1007px)': {
      fontSize: '2em',
    }
  },
  subline: {
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '1.3em',
    lineHeight: '1.36em'
  },
  vidContainer: {
    position: 'relative',
    width: '66%',
    display: 'inline-block',
    transform: 'translateY(-24px)',
    '@media screen and (max-width: 1380px)': {
      width: '55%',
    },
    '@media screen and (max-width: 1007px)': {
      display: 'block',
      width: '100%',
    }
  },
  vidHolster: {
    position: 'absolute',
    borderRadius: 4,
    overflow: 'visible',
    opacity: 0,
    width: '100%',
    transform: 'scale(.9)',
    boxShadow: '0 27px 100px 6px rgba(24,0,8,0.17)',
    transition: 'transform 300ms ease-out'
  },
  scaled: {
    opacity: 1,
    transform: 'scale(1)'
  },
  carouselHolster: {
    float: 'right',
    width: '33%',
    padding: '40px 90px 0 20px',
    '@media screen and (max-width: 1380px)': {
      width: '45%',
    },
    '@media screen and (max-width: 1007px)': {
      display: 'none'
    }
  },
  carouselBtn: {
    marginBottom: 10,
    textAlign: 'left',
    padding: '14px 20px',
    backgroundColor: Palette.GRAY,
    transition: 'color 290ms ease',
    ':hover': {
      color: Palette.LIGHT_BLUE
    }
  },
  carouselActive: {
    backgroundColor: Palette.FATHER_COAL,
    color: Palette.LIGHT_BLUE
  },
  carouselTextWrapper: {
    position: 'relative'
  },
  carouselText: {
    padding: 14,
    opacity: 0,
    position: 'absolute',
    top: 0,
    left: 0,
    transform: 'translateY(20px)',
    transition: 'transform 300ms ease-out'
  },
  arrived: {
    transform: 'translateY(0)',
    opacity: 1
  },
  carouselIcon: {
    marginRight: 8,
    transform: 'translateY(2px)',
    display: 'inline-block'
  },
  connectorWrapper: {
    padding: '0 80px',
    marginTop: 70,
    '@media screen and (max-width: 1380px)': {
      padding: 0,
      marginTop: 0
    }
  },
  connectorFoundation: {
    backgroundColor: Palette.COAL,
    width: 740,
    margin: '0 auto',
    borderRadius: 10,
    padding: '40px 100px',
    '@media screen and (max-width: 1007px)': {
      width: '100%',
      padding: '10px 20px',
      backgroundColor: 'transparent'
    }
  },
  soonCards: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    padding: '0 100px',
    '@media screen and (max-width: 1007px)': {
      flexWrap: 'wrap'
    }
  },
  cardWrap: {
    float: 'left',
    textAlign: 'center',
    margin: '40px 30px 0',
    maxWidth: 380,
  },
  soonTitle: {
    fontSize: '1.4em',
    marginBottom: 10,
    marginTop: 30,
    textTransform: 'uppercase',
    fontFamily: '"brandon-grotesque", sans-serif !important',
  },
  soonBody: {
    fontSize: '1em',
    lineHeight: '1.3em'
  },
  hr: {
    borderColor: Color(Palette.DARK_GRAY).fade(.8),
    marginBottom: 10,
  },
  ...BTN_STYLES
}

class Home extends Component {
  constructor() {
    super()

    this.state = {
      finishedLoad: false,
      windowWidth: windowPresent ? window.innerWidth : 1920,
      windowHeight: windowPresent ? window.innerHeight : 1920,
      videoPlayerOpen: false,
      mouX: null,
      mouY: null,
      carousel: 0,
      carouselOverride: false,
      carouselDurations: [6200, 9000, 13300],
      btnHovered: false
    }

    this.carouselTimer = null
  }

  componentDidMount() {
    this.setState({ windowWidth: windowPresent ? window.innerWidth : 1920 })
    this.setState({ finishedLoad: true })
    windowPresent && window.addEventListener("resize", this.updateDimensions)
    // window.fbq('track', 'LoadHomepage')

    if (this.props.location.hash) {
      scrollToComponent(this[this.props.location.hash.substr(1)], { align: 'top' });
    }

    this.playbackController(0)
    this.progressCarousel(this.state.carouselDurations[this.state.carousel])
  }

  componentWillUnmount() {
    windowPresent && window.removeEventListener("resize", this.updateDimensions)
    if (this.orientationHandler) windowPresent && window.removeEventListener("deviceorientation", this.orientationHandler)
    clearTimeout(this.carouselTimer);
  }

  updateDimensions = debounce(() => {
    this.setState({ windowWidth: windowPresent ? window.innerWidth : 1920, windowHeight: windowPresent ? window.innerHeight : 1920 })
  }, 40)

  setMouseCoordinates = throttle(({ clientX, clientY }) => {
    this.setState({ mouX: clientX, mouY: clientY })
  }, 16)

  mouseMoveCallback = (mouseEvent) => {
    mouseEvent.persist()
    this.setMouseCoordinates(mouseEvent)
  }

  progressCarousel(currentVidDuration) {
    if (window.location.pathname != '/') return false
    this.carouselTimer = setTimeout(() => {
      const pages = this.state.carouselDurations.length
      let page = this.state.carousel
      let nextPage = page === pages - 1 ? 0 : page + 1
      this.setState({ carousel: nextPage })
      this.playbackController(nextPage)
      !this.state.carouselOverride && this.progressCarousel(this.state.carouselDurations[this.state.carousel])
    }, currentVidDuration)
  }

  handleCarouselClick(page) {
    clearTimeout(this.carouselTimer);
    this.setState({
      carousel: page,
      carouselOverride: true
    })
    this.playbackController(page)
  }

  playbackController(page) {
    const video = this.refs['vid' + page]
    this.refs.vid0.currentTime = 0
    this.refs.vid1.currentTime = 0
    this.refs.vid2.currentTime = 0
    video.play()
  }
 
  render() {
    const { carousel } = this.state

    return (
      <div className="home-root" style={{ opacity: this.state.finishedLoad ? 1 : 0 }}>

        <Helmet>
          <title>Haiku | Create interfaces using design tools, code or both.</title>
          <meta name="description" content="Where designing is building. Create dynamic, cross-platform UIs using design tools, code, or both. Works with any iOS, Android, or Web codebase." />
        </Helmet>

        <div style={{ position: 'relative', overflowX: 'hidden' }}
          id='top'
          onMouseMove={this.mouseMoveCallback}>
          {(!isMobile && this.state.windowWidth > 737) &&
            <Navbar location="home" />
          }
          <div style={[STYLES.hero, this.state.windowHeight < 500 && { height: 650 }]}>
            <Hero windowWidth={this.state.windowWidth} />
          </div>

          <div id="overview" style={[STYLES.section, STYLES.overviewContainer]}>
            <div style={STYLES.vidContainer}>
              <video
                ref="vid0"
                style={[STYLES.vidHolster, carousel === 0 && STYLES.scaled]}
                loop muted playsInline preload="metadata">
                <source src={vid0} type="video/mp4" />
              </video>
              <video
                ref="vid1"
                style={[STYLES.vidHolster, carousel === 1 && STYLES.scaled]}
                loop muted playsInline preload="metadata">
                <source src={vid1} type="video/mp4" />
              </video>
              <video
                ref="vid2"
                style={[STYLES.vidHolster, carousel === 2 && STYLES.scaled]}
                loop muted playsInline preload="metadata">
                <source src={vid2} type="video/mp4" />
              </video>
            </div>
            <span style={STYLES.carouselHolster}>
              <div
                key='carousel-btn1' 
                onClick={() => this.handleCarouselClick(0)}
                style={[
                  STYLES.btn,
                  STYLES.carouselBtn,
                  carousel === 0 && STYLES.carouselActive
                ]}>
                <span style={STYLES.carouselIcon}>
                  <MotionSVG color={this.state.carousel === 0 ? Palette.SUNSTONE : Palette.ROCK} />
                </span>
                Interactive Motion
              </div>
              <div
                key='carousel-btn2' 
                onClick={() => this.handleCarouselClick(1)}
                style={[
                  STYLES.btn,
                  STYLES.carouselBtn,
                  carousel === 1 && STYLES.carouselActive
                ]}>
                <span style={STYLES.carouselIcon}>
                  <ComponentSVG color={this.state.carousel === 1 ? Palette.SUNSTONE : Palette.ROCK} />
                </span>
                Universal Components
              </div>
              <div
                key='carousel-btn3' 
                onClick={() => this.handleCarouselClick(2)}
                style={[
                  STYLES.btn,
                  STYLES.carouselBtn,
                  carousel === 2 && STYLES.carouselActive
                ]}>
                <span style={[STYLES.carouselIcon, {transform: 'translateY(-1px)'}]}>
                  <CodeSVG color={this.state.carousel === 2 ? Palette.SUNSTONE : Palette.ROCK} />
                </span>
                Reads & Writes Code
              </div>
              <hr style={STYLES.hr}/>
              <div style={STYLES.carouselTextWrapper}>
                <div style={[STYLES.carouselText, carousel === 0 && STYLES.arrived]}>Add delight to any UI.  Haiku's powerful visual timeline gives you unlimited control of animations and interactions, so you can finally create the experience you imagine.</div>
                <div style={[STYLES.carouselText, carousel === 1 && STYLES.arrived]}>Haiku's Universal Component Format is the missing link between design and code.  Create UI components for any React, Angular, or Vue app using your designs from Sketch, Figma, or Illustrator — all through one seamless workflow.</div>
                <div style={[STYLES.carouselText, carousel === 2 && STYLES.arrived]}>Haiku is the only design tool that reads and writes code as its source of truth. Edit your projects through design, code, or both.  Iterate between design and code like never before.</div>
              </div>
            </span>
          </div>

          <div id="workflow-connector" style={STYLES.section}>
            <h2 style={STYLES.h2}>HAIKU CONNECTS YOUR TEAM & TOOLS</h2>
            <div style={STYLES.subline}>
              Haiku speaks both design and code — providing the bridge that<br/>connects your digital product workflow
            </div>
            <div style={STYLES.connectorWrapper}>
              <Workflowstate loop={true} sizing='contain' />
            </div>
            <div style={STYLES.connectorFoundation}>
                Design in your drawing tools; orchestrate in Haiku; then snap into your codebase. Make updates to production anywhere along the way.
            </div>
          </div>
          <div id="pricing" style={[STYLES.section, {textAlign: 'center', margin: '0 auto 120px'}]}>
            <h2 style={STYLES.h2}>Get Haiku for free</h2>
            <div style={[
              { width: 292, marginBottom: -16, transform: 'translateY(27px)', display: 'inline-block' },
              isSafari && { transform: 'translateY(10px)'},
              (this.state.windowWidth < 800 || isFirefox) && { display: 'none' }
            ]}>
              <Beholder loop={true} haikuStates={{ btnHovered: { "value": this.state.btnHovered } }}/>
            </div>
            <div style={[STYLES.connectorFoundation,{ padding: '70px 100px', }]}>
              <div style={[STYLES.subline, { marginBottom: 40 }]}>
                  All of Haiku's core functionality is free to use,<br />
                  built on an <a href="https://github.com/HaikuTeam/core" target="_blank">open-source renderer & file format</a>.
              </div>
              <a href={`${process.env.ACCOUNT_SITE_URL}/new`}>
                <div
                key='cta2'
                onMouseOver={() => this.setState({btnHovered: true})}
                onMouseOut={() => this.setState({ btnHovered: false })}
                style={[STYLES.btn, STYLES.cta, {display: 'inline-block'}]}>Get Haiku Free</div>
              </a>
            </div>
          </div>
          <MobileContent />
        </div>
      </div>
    )
  }
}

export default Radium(Home)






/*
TP: WIll put this static version of soon on /feature isntead of here on landing tomorrow:

          <div id="More Soon" style={STYLES.section}>
            <h2 style={STYLES.h2}>The Ultimate Design & Build System</h2>
            <div style={STYLES.subline}>
              We're just getting started. Keep an eye out for more game-changers:
            </div>
            <div style={STYLES.soonCards}>
              <div style={STYLES.cardWrap}>
                <img
                  src={soon01}
                  alt="soon01"
                  style={[
                    { width: 230 }
                  ]} />
                <div id='title' style={STYLES.soonTitle}>Layouts & UI Prefabs</div>
                <div id='body' style={STYLES.soonBody}>Powerful layouts & drag-and-drop customizable UI widgets</div>
              </div>
              <div style={STYLES.cardWrap}>
                <img
                  src={soon02}
                  alt="soon02"
                  style={[
                    { width: 230 }
                  ]} />
                <div id='title' style={STYLES.soonTitle}>MARKETPLACE</div>
                <div id='body' style={STYLES.soonBody}>For sharing or selling your components with teammates and the world</div>
              </div>
              <div style={STYLES.cardWrap}>
                <img
                  src={soon03}
                  alt="soon03"
                  style={[
                    { width: 230 }
                  ]} />
                <div id='title' style={STYLES.soonTitle}>PHYSICS</div>
                <div id='body' style={STYLES.soonBody}>Get creative with interuptable physics simulations</div>
              </div>
            </div>
            <div style={STYLES.soonCards}>
              <div style={STYLES.cardWrap}>
                <img
                  src={soon04}
                  alt="soon04"
                  style={[
                    { width: 230 }
                  ]} />
                <div id='title' style={STYLES.soonTitle}>LIVE DESIGN</div>
                <div id='body' style={STYLES.soonBody}>Living design systems with hot modules from design to codebase</div>
              </div>
              <div style={STYLES.cardWrap}>
                <img
                  src={soon05}
                  alt="soon05"
                  style={[
                    { width: 230 }
                  ]} />
                <div id='title' style={STYLES.soonTitle}>HAIKU FOR TEAMS</div>
                <div id='body' style={STYLES.soonBody}>Visual version control, commenting and real-time collab</div>
              </div>
            </div>
          </div>








TP: We'll switch to this Haiku'd version soon




<div style={STYLES.soonCards}>
              <div style={STYLES.cardWrap}>
                <SoonCard loop={true} haikuStates={{ card: { "value": 1 }}}>
                  <div id='title' style={STYLES.soonTitle}>Layouts & UI Prefabs</div>
                  <div id='body' style={STYLES.soonBody}>Powerful layouts & drag-and-drop customizable UI widgets</div>
                </SoonCard>
              </div>
              <div style={STYLES.cardWrap}>
                <SoonCard loop={true} haikuStates={{ card: { "value": 2 }}}>
                  <div id='title' style={STYLES.soonTitle}>MARKETPLACE</div>
                  <div id='body' style={STYLES.soonBody}>For sharing or selling your components with teammates and the world</div>
                </SoonCard>
              </div>
              <div style={STYLES.cardWrap}>
                <SoonCard loop={true} haikuStates={{ card: { "value": 3 }}}>
                  <div id='title' style={STYLES.soonTitle}>PHYSICS</div>
                  <div id='body' style={STYLES.soonBody}>Get creative with interuptable physics simulations</div>
                </SoonCard>
              </div>
            </div>
            <div style={STYLES.soonCards}>
              <div style={STYLES.cardWrap}>
                <SoonCard loop={true} haikuStates={{ card: { "value": 4 }}}>
                  <div id='title' style={STYLES.soonTitle}>LIVE DESIGN</div>
                  <div id='body' style={STYLES.soonBody}>Living design systems with hot modules from design to codebase</div>
                </SoonCard>
              </div>
              <div style={STYLES.cardWrap}>
                <SoonCard loop={true} haikuStates={{ card: { "value": 5 } }}>
                  <div id='title' style={STYLES.soonTitle}>HAIKU FOR TEAMS</div>
                  <div id='body' style={STYLES.soonBody}>Visual version control, commenting and real-time collab</div>
                </SoonCard>
              </div>
            </div>
*/


// WEBPACK FOOTER //
// ./src/pages/index.js